import { render, staticRenderFns } from "./StudioHome.vue?vue&type=template&id=4c20e40e&scoped=true&"
import script from "./StudioHome.vue?vue&type=script&lang=js&"
export * from "./StudioHome.vue?vue&type=script&lang=js&"
import style0 from "./StudioHome.vue?vue&type=style&index=0&id=4c20e40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c20e40e",
  null
  
)

export default component.exports